import { ErrorBoundary } from 'react-error-boundary';
import { Drawer } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { NAV_HEIGHT } from '@/components/Nav/sizes';
import { useAIChatDrawer } from './hooks/useAIChatDrawer';
import { useBannerHeight } from '@/hooks/useBannerHeight';
import { CopilotKitAIChatDrawerContent } from './CopilotKitAIChatDrawerContent';
import { AIChatCrashFallback } from '@/pages/AIChatCopilotKit/CopilotKitInitErrorBanner';

const StyledDrawer = styled(Drawer)<{ $bannerHeight: string }>`
  top: calc(${NAV_HEIGHT} + ${props => props.$bannerHeight});
  height: calc(100vh - ${NAV_HEIGHT} - ${props => props.$bannerHeight});
`;

type CopilotKitAIChatDrawerProps = {
  visible: boolean;
  onClose: () => void;
};

/**
 * CopilotKit AI Chat Drawer
 *
 * A single Drawer shell that contains an ErrorBoundary and the drawer content.
 */
export const CopilotKitAIChatDrawer = ({
  visible,
  onClose,
}: CopilotKitAIChatDrawerProps) => {
  const { t } = useTranslation('ai-chat');
  const { drawerProps } = useAIChatDrawer();
  const bannerHeight = useBannerHeight();

  return (
    <StyledDrawer
      {...drawerProps}
      visible={visible}
      onHide={onClose}
      aria-label={t('drawer.ariaLabel')}
      testId="copilotkit-ai-chat-drawer"
      $bannerHeight={bannerHeight}>
      <ErrorBoundary FallbackComponent={AIChatCrashFallback}>
        <CopilotKitAIChatDrawerContent onClose={onClose} visible={visible} />
      </ErrorBoundary>
    </StyledDrawer>
  );
};
